import { parseApiTimestampToUnixMs } from './parse-api-timestamp-to-unix-ms';

/**
 * 公開 Storage オブジェクト URL。`objectPath` が無いときは null。
 * `cacheBustAt` は `?v=` 用（ISO / Date / API 日時文字列）。
 */
export function buildPublicStorageObjectUrl(
  supabaseUrl: string,
  bucket: string,
  objectPath: string | null | undefined,
  cacheBustAt?: string | Date | null,
): string | null {
  const path = objectPath?.trim();
  if (!path) return null;
  const base = supabaseUrl.replace(/\/$/, '');
  const url = `${base}/storage/v1/object/public/${bucket}/${path}`;
  if (cacheBustAt == null || cacheBustAt === '') return url;
  const ms =
    cacheBustAt instanceof Date
      ? cacheBustAt.getTime()
      : parseApiTimestampToUnixMs(cacheBustAt);
  if (ms == null || Number.isNaN(ms)) return url;
  return `${url}?v=${ms}`;
}
